import { getEnvConfig } from './siteConfig';

/** Resolved from endpoint.json via siteConfig.getEnvConfig() */
export const ENV = getEnvConfig();
export const ASW_S3_LINK = ENV.ASW_S3_LINK;
export const CLOUD_FRONT = ENV.CLOUD_FRONT;
export const SITE_URL = ENV.URL;
export const CDN = ENV.CDN;

const BASE_URL = ENV.BASE;
export const SOCKET = ENV.SOCKET;
export const MEDIA_FORGE = ENV.MEDIA_FORGE;

export const splashUrl = `${BASE_URL}/splash`;

/** Get the global Configuration for ringO. TODO: Set the ring to be picked up based on environment */
export const globalConfigUrl = `${BASE_URL}/globalConfiguration?ring=ring0`;

/** Get the specific global configuration by ID */
export const globalConfigurationByIdUrl = `${BASE_URL}/globalConfiguration/${ENV.GLOBAL_CONFIG_ID}`;

/** USERS API */
export const getPhoneVerificationCodeUrl = `${BASE_URL}/users/signup`;
export const phoneNumberVerificationUrl = `${BASE_URL}/users/reg-phone-verify`;
export const validateFieldUrl = `${BASE_URL}/users/user-existing-status`;
export const validateUsernameUrl = `${BASE_URL}/users/userName-check`;
export const loginUrl = `${BASE_URL}/users/login`;
export const logoutUrl = `${BASE_URL}/users/logout`;
export const login2FAVerifyUrl = `${BASE_URL}/users/login-phone-verify`;
export const forgotPasswordUrl = `${BASE_URL}/users/forgotPassword`;
export const resetPasswordUrl = `${BASE_URL}/users/resetPassword`;
export const changePasswordUrl = `${BASE_URL}/users/updateMyPassword`;
export const userConfigurationUrl = `${BASE_URL}/config`;
export const refreshTokenUrl = `${BASE_URL}/users/refresh`;
export const getUserProfileUrl = `${BASE_URL}/users/userdashboard`;
export const userBaseUrl = `${BASE_URL}/users`;
export const dashboardUrl = `${BASE_URL}/users/board`;
/** Admin multi-filter audience builder (email / CRM). Not for typeahead. */
export const usersAdminAdvancedSearchUrl = `${userBaseUrl}/admin/advanced-search`;
export const usersAdminAdvancedSearchFilterOptionsUrl = `${userBaseUrl}/admin/advanced-search/filter-options`;

export const updateProfileUrl = `${BASE_URL}/users/updateMe`;

/** The below will take a token `:token in a GET call` */
export const verifyEmailUrl = `${BASE_URL}/users/verifyEmail`;
export const initiateEmailVerificationUrl = `${BASE_URL}/users/initiate-email-verification`;
/** The below API, replaces the accounts api call, that fetched all user information
 * including configuration. This is now a one API call that will do all that work and return the
 * same amount of data. It takes a GET call,
 */
export const userDetailsUrl = `${userBaseUrl}/userdetails`;
export const userDeleteUrl = `${userBaseUrl}/delete`;

/** MOVIES API */
export const getHomeScreenItemsUrl = `${BASE_URL}/movies/preference/home`;
export const getHomePageCategoriesUrl = `${BASE_URL}/movies?fields=genre`;
export const getMoviesUrl = `${BASE_URL}/movies`;
export const getWatchListUrl = `${BASE_URL}/like/get-my-likes`;
/** Accepets a `movieId` string as param `PATCH` request  and `DELETE` */
export const addRemoveMovieLocationUrl = `${BASE_URL}/movies/imagelocation`;
/** Accepets a `movieId` string as param `DELETE` request with a body of `{filekey: name_of_file}` */
export const deleteGalleryImageUrl = `${BASE_URL}/movies/image/`;
export const deleteSingleImageUrl = `${BASE_URL}/movies/singleimage/`;

/** TALENT PROFILE API. CONC Additional Params for search or filter. POST, UPDATE, DELETE */
export const talentProfileBaseUrl = `${BASE_URL}/profiles`;
export const talentReviewBaseUrl = `${BASE_URL}/talent-review`;
/** The below takes the `ID` of the profile. It is also used to delete single picture from gallery */
export const uploadTalentImagesUrl = `${BASE_URL}/profiles/upload`;
export const deleteTalentSingleImageUrl = `${BASE_URL}/profiles/singleimage`;
export const getMyTalentProfileurl = `${BASE_URL}/profiles/get-my-profile`;
export const searchTalentUrl = `${BASE_URL}/profiles/general/search`;
export const filterTalentUrl = `${BASE_URL}/profiles/filter`;

/** LIKE API */
export const likeUrl = `${BASE_URL}/like`;
export const deletLikeUrl = `${BASE_URL}/like/delete-favourite`;
export const deleteReviewLikeurl = `${BASE_URL}/like/delete-like`;
/** TO UPDATE A REVIEW, USE PATCH AND HAVE LIKE_TYPE IN THE BODY OF THE REQUEST */
export const reviewUrl = `${BASE_URL}/reviews`;

/** Get The Review Likes and Movies of current user */
export const getMyLikesUrl = `${BASE_URL}/like/get-my-likes`;

/** Search Result yielding both movies and bio */
export const searchUrl = `${BASE_URL}/movies/general/search`;

/** Get Biography Details- Supports POST, GET (WITH ID), GET_ALL, DELETE (WITH ID) */
export const biographyUrl = `${BASE_URL}/bio`;
/** handles both delete and upload patch */
export const singleGalleryAndProfileImagesUrl = `${BASE_URL}/bio/upload`;
export const deleteBioSingleImageUrl = `${BASE_URL}/bio/singleImage`;

/** Get Credits */
export const creditUrl = `${BASE_URL}/credits`;
export const getBioMoviesCredit = `${BASE_URL}/credits?user=`;

/** Get Auditions */
export const getAuditionUrl = `${BASE_URL}/auditions`;
export const getMyAuditionsUrl = `${getAuditionUrl}/get-my-auditions`;
export const auditionInviteUserUrl = (auditionId: string) => `${getAuditionUrl}/${auditionId}/invite-user`;

/** Apply to auditions, takes ID of Audition POST or DELETE or UPDATE (To sort Application) */
export const applyToAuditionUrl = `${BASE_URL}/applications`;

/** Get My Applications */
export const getMyApplicationsUrl = `${BASE_URL}/applications/get-my-applications`;
/** Ensure that you clal `.replace('#id#, payload)` - payload being the audition ID */
export const getApplicationsForOneAuditionUrl = `${BASE_URL}/auditions/#id#/applications/get-audition-applications`;

/** Get Roles */
export const getAuditionRolesUrl = `${BASE_URL}/roles?audition=`;
export const createAuditionRoleUrl = `${BASE_URL}/audition/{{:auditionId}}/roles`;
export const getAuditionRoleUrl = `${BASE_URL}/roles`;

/** Get Reviews */
export const getMyReviewsUrl = `${BASE_URL}/reviews/get-my-reviews`;

/** Payment Methods Paystack */
export const addNewPaymentMethodUrl = `${BASE_URL}/payment/add-payment-method`;
export const getMyPaymentMethodsUrl = `${BASE_URL}/payment/get-my-payment-methods`;
/** The Below also serves for delete and update payment method */
export const paymentMethodUrl = `${BASE_URL}/payment/`;
/** Works for US customers and Stripe Integration */
export const addPaymentMethodUrl = `${BASE_URL}/payment/add-new-card`;
export const processPaymentUrl = `${BASE_URL}/sales`;
export const alternateAddPaymentMethodUrl = `${BASE_URL}/payment/add-authorization`;
export const verifyDiscountUrl = `${BASE_URL}/reedemable-code/discount/verify`;
export const calculateFeesUrl = `${BASE_URL}/mixed/sales-calc`;

export const createPaymentIntentUrl = `${BASE_URL}/payment/create-payment-intent`;
export const createPaymentIntentForSinglePurchaseUrl = `${BASE_URL}/payment/purchase/create-payment-intent`;
export const verifyPaystackPurchaseUrl = `${BASE_URL}/payment/purchase/verify-paystack`;
export const verifyFlutterwavePurchaseUrl = `${BASE_URL}/payment/purchase/verify-flutterwave`;
export const paymentRailUrl = `${BASE_URL}/payment/rail`;
export const adminPaymentRailCountriesUrl = `${BASE_URL}/payment/admin/rail-countries`;
export const adminAssignPaymentRailCountriesUrl = `${BASE_URL}/payment/admin/rail-countries/assign`;
export const getPublishableKeyUrl = `${BASE_URL}/payment/pub-key`;
/** Flutterwave Billing — tokenize card without a subscription */
export const initializeFlutterwaveBillingCardUrl = `${BASE_URL}/payment/initialize-flutterwave-card`;
export const verifyFlutterwaveBillingCardUrl = `${BASE_URL}/payment/verify-flutterwave-card`;

/** Subscription API URL */
export const createSubscriptionUrl = `${BASE_URL}/subscribe`;
export const createSubscriptionStripeUrl = `${BASE_URL}/subscribe/create-subscription`;
export const getMySubscriptionUrl = `${BASE_URL}/subscribe/get-my-plan`;
/** Cancel Subscription, takes Mongo `_id` */
export const cancelSubscriptionUrl = `${BASE_URL}/subscribe/cancel/`;
/** Update payment — Mongo `_id` or Paystack subscription_code */
export const updateSubscriptionUrl = `${BASE_URL}/subscribe/updatePayment/`;
/** Reactivate Paystack subscription — Mongo `_id` only */
export const activateCreatorSubscriptionUrl = `${BASE_URL}/subscribe/activate/`;
/** Admin: list grantable creator plans (Starter / Pro / Pro Plus) */
export const adminCreatorSubscriptionPlansUrl = `${BASE_URL}/subscribe/admin/plans`;
/** Admin: grant creator plan without payment */
export const adminCreatorSubscriptionGrantUrl = `${BASE_URL}/subscribe/admin/grant`;
/** Super-admin: creator subscription directory */
export const adminCreatorSubscriptionsUrl = `${BASE_URL}/subscribe/admin/subscriptions`;
export const adminExpireCreatorTrialUrl = (id: string) =>
    `${BASE_URL}/subscribe/admin/subscriptions/${id}/expire-trial`;
export const adminCancelCreatorSubscriptionUrl = (id: string) =>
    `${BASE_URL}/subscribe/admin/subscriptions/${id}/cancel`;
export const adminSwitchCreatorPaystackPlanUrl = (id: string) =>
    `${BASE_URL}/subscribe/admin/subscriptions/${id}/switch-paystack-plan`;
export const adminChargeCreatorPaystackAuthorizationUrl = (id: string) =>
    `${BASE_URL}/subscribe/admin/subscriptions/${id}/charge-authorization`;
export const adminResetCreatorTrialUrl = (userId: string) => `${BASE_URL}/subscribe/admin/users/${userId}/reset-trial`;
export const getSubscriptionPlansUrl = `${BASE_URL}/plan/stripe`;
export const getSubscriptionPlansPaystackUrl = `${BASE_URL}/plan/paystack`;
export const getSubscriptionPlansFlutterwaveUrl = `${BASE_URL}/plan/flutterwave`;
export const planBaseUrl = `${BASE_URL}/plan`;
export const syncCreatorFlutterwavePlansUrl = (id?: string) =>
    id ? `${planBaseUrl}/${id}/sync-flutterwave-plans` : `${planBaseUrl}/sync-flutterwave-plans`;

/** Event host subscription packages */
export const eventHostPackagesUrl = `${BASE_URL}/event-host-packages`;
export const syncEventHostFlutterwavePlansUrl = (id: string) => `${eventHostPackagesUrl}/${id}/sync-flutterwave-plans`;
export const initializePaystackSubscriptionUrl = `${BASE_URL}/subscribe/initialize-paystack`;
export const verifyPaystackSubscriptionUrl = `${BASE_URL}/subscribe/verify-paystack`;
export const initializeFlutterwaveSubscriptionUrl = `${BASE_URL}/subscribe/initialize-flutterwave`;
export const verifyFlutterwaveSubscriptionUrl = `${BASE_URL}/subscribe/verify-flutterwave`;

/** Save Items takes an object with `{details: { type: 'Role', model: modelId}}` type can be `Role | Audition | Any collection name` */
export const saveCollectionUrl = `${BASE_URL}/save`;
export const getSavedCollectionUrl = `${BASE_URL}/save/get-my-saved-collection`;

/** Festivals */
export const getFestival = `${BASE_URL}/festivals`;
export const getFestivalHomeItems = `${BASE_URL}/festivals/festivalhome`;
/** Takes a param id as string --- `/?festival=`id`` */
export const getFestivalAwardcategoryUrl = `${BASE_URL}/awardcategory`;

/** Awards */
export const awardsUrl = `${BASE_URL}/award`;
export const awardsCategoryUrl = `${BASE_URL}/awardcategory`;

/** Message Rooms */
export const roomsUrl = `${BASE_URL}/rooms`;
export const getMyRoomsUrl = `${roomsUrl}/my-rooms`;
export const getMessageUrl = `${BASE_URL}/message`;
/** Must pass Id of reciver `/:id` */
export const findUnqiueRoom = `${roomsUrl}/uniqueroom`;
/**
 * Takes a GET Call with query params
 * searchTerm: String
 * page: number; default to 1
 * limit: number. Default to 20
 * Optional Takes searchMessages which can be true or false to also search the message_content
 */
export const searchRoomsUrl = `${BASE_URL}/rooms/search`;

export const webNotificationsUrl = `${BASE_URL}/webnotification`;
export const getCurrentUserWebNotificationsUrl = `${webNotificationsUrl}/user-notifications`;

/** Save Adopter */
export const adopterUrl = `${BASE_URL}/adopter`;

/** Recommend URL */
export const recommendationUrl = `${BASE_URL}/recommendations/send`;

export const discoverUrl = `${BASE_URL}/profiles/talent-facet`;
export const castingDirectorUrl = `${BASE_URL}/company`;
export const getMycastingDirectorProfileurl = `${castingDirectorUrl}/get-my-profile`;

/**Acts takes `:id` for delete and update*/
export const actsUrl = `${BASE_URL}/acts`;
export const myActsUrl = `${BASE_URL}/acts/get-my-acts`;
export const actsUrlbase = `${BASE_URL}/acts`;
/** Add :id to get the act */
export const actsUrlByIdentifier = `${BASE_URL}/acts/watch`;
export const getMyActsUrl = `${actsUrlbase}/get-my-acts`;

/** Recommendations  GET request*/
export const getRecommendationUrl = `${BASE_URL}/contest/recommendation`;

/** Projects */
export const getMyProjectsUrl = `${BASE_URL}/mixed/search-user-projects`;
export const projectUrl = `${BASE_URL}/project`;
export const adminProjectsUrl = `${BASE_URL}/project/admin/all`;
export const adminProjectFeaturedUrl = (id: string) => `${BASE_URL}/project/admin/${id}/featured`;
/** Platform sample / example videos shown on contest details by viewer country */
export const adminContestSampleVideosUrl = `${BASE_URL}/admin/contest-sample-videos`;
export const contestSampleVideosUrl = `${BASE_URL}/contest/sample-videos`;
/** Twilio Content API / WhatsApp templates (admin) */
export const adminTwilioContentTemplatesUrl = `${BASE_URL}/admin/twilio-content-templates`;
export const adminTwilioContentTemplateImportUrl = `${adminTwilioContentTemplatesUrl}/import`;
export const adminTwilioContentTemplateSubmitApprovalUrl = (id: string) =>
    `${adminTwilioContentTemplatesUrl}/${id}/submit-approval`;
export const adminTwilioContentTemplateRefreshApprovalUrl = (id: string) =>
    `${adminTwilioContentTemplatesUrl}/${id}/refresh-approval`;
export const adminTwilioContentTemplatePurposeUrl = (id: string) => `${adminTwilioContentTemplatesUrl}/${id}/purpose`;
/** Admin / DEV: send opportunity Y/N invite (SMS / WhatsApp / email) for testing */
export const adminOpportunityInviteTestUrl = `${BASE_URL}/admin/opportunity-invites/test`;

/** Content categories + subcategories (source of truth) */
export const contentCategoriesUrl = `${BASE_URL}/content-categories`;
export const adminContentCategoriesUrl = `${contentCategoriesUrl}/admin`;
export const adminContentCategoryUrl = (id: string) => `${contentCategoriesUrl}/${id}`;
export const adminContentCategorySeedUrl = `${contentCategoriesUrl}/seed`;
export const adminContentCategorySubUrl = (id: string, subId: string) =>
    `${contentCategoriesUrl}/${id}/subcategories/${subId}`;
export const adminContentCategorySubsUrl = (id: string) => `${contentCategoriesUrl}/${id}/subcategories`;

/** Admin influencer management (featured, categories, profile photo) */
export const adminInfluencersUrl = `${BASE_URL}/admin/influencers`;
export const adminInfluencerFeaturedUrl = (id: string) => `${adminInfluencersUrl}/${id}/featured`;
export const adminInfluencerUrl = (id: string) => `${adminInfluencersUrl}/${id}`;
export const adminInfluencerProfilePictureUrl = (id: string) => `${adminInfluencersUrl}/${id}/profile-picture`;

/** Contest submission mode (tier ↔ regular). Append `/:contestId`. */
export const contestSubmissionModeUrl = (contestId: string) => `${BASE_URL}/contest/${contestId}/submission-mode`;
export const contestSubmissionModeToRegularUrl = (contestId: string) =>
    `${contestSubmissionModeUrl(contestId)}/to-regular`;
export const contestSubmissionModeToTierUrl = (contestId: string) => `${contestSubmissionModeUrl(contestId)}/to-tier`;
/** Take an `/id` to upload */
export const uploadProjectMediaUrl = `${BASE_URL}/project/upload`;
export const publishProjectUrl = `${BASE_URL}/project/publish`;
export const unPublishProjecturl = `${BASE_URL}/project/unpublish`;
/** Take an ID */
export const getSignedUrlForProject = `${BASE_URL}/project/getSignedUrl`;
export const getSignedUrlForThumbnail = `${BASE_URL}/project/getSignedUrl/feature`;

/** Take an  `id` as param */
export const watchUrl = `${BASE_URL}/project/watch`;
export const cookieUrl = `${BASE_URL}/project/cookie`;
export const submissionsUrl = `${BASE_URL}/submission`;
export const getMySubmissionsUrl = `${submissionsUrl}/get-my-submissions`;
/** **Important**:  Pass `:id` as the contestId to populate it's submissions
 * To auto assign to all juries use `-POST` `{auto_populate: boolean}`. pass auto_populate as true
 * To manually assign use  `{auto_populate: false, submission: submissionId, user: userId, jury: juryId}`
 */
export const juryUrl = `${BASE_URL}/jury`;

export const assignSubmissionToJuryurl = `${submissionsUrl}/distribute/`;
/** get my Jury Assignment. Gets assignment for logged in juror */
export const juryAssignmentUrl = `${submissionsUrl}/jury`;
/** Gets Submission for selected juryAssignment. **IMPORTANT** pass :contestId
 * also takes `?limit=0&page=1` for pagination
 */
export const juryAssignmentSubmissionsUrl = `${submissionsUrl}/jury-submisisons/`;
/** `- PATCH` with `submisisonId` and payload of score */
export const scoreSubmissionsUrl = `${submissionsUrl}/score/`;
export const scoreBoardUrl = `${submissionsUrl}/scoreboard`;

/** Dashboard */
export const getUserDashboardUrl = `${BASE_URL}/users/dashboard`;

/** Discovery - Get the discovery home items*/
export const getDiscoveryUrl = `${BASE_URL}/contest/home`;
export const getUgcHighlightVideosUrl = `${BASE_URL}/contest/home/ugc-highlights`;

/** Coming soon*/
export const getComingSoonUrl = `${BASE_URL}/contest/coming-soon`;

/** Search Discovery Screen */
export const searchDiscoveryUrl = `${BASE_URL}/contest/search`;

/** Get Contest Details => Take an `GET` with an `id` to fetch the details of one contest */
export const getContestUrl = `${BASE_URL}/contest`;
export const getContestWithContestIdUrl = `${BASE_URL}/contest/event`;
/** Take a POST call with key as payload */
export const downloadContestAssetUrl = `${getContestUrl}/download`;
export const publishContestUrl = `${getContestUrl}/publish`;
export const unPublishContesturl = `${getContestUrl}/unpublish`;
/** This takes an :id in its url param */
export const uploadContestVideoUrl = `${getContestUrl}/upload/`;
/** Also takes :id in it's param */
export const getContestMetricsUrl = `${getContestUrl}/metrics/`;
/** Takes :id in its url param */

export const winnersEmailUrl = `${getContestUrl}/conclusion-email`;

/** Activity Url
 * The below also accepts ?activity_type=`Check activity redux types to see the different types`. To filter the activity for the logged in user
 * An example for use here is returning users most recent searches pass `?activity_type=initiated a search`. Supports `POST` as well as `GET` requests
 */
export const activityUrl = `${BASE_URL}/activity`;

/** Suggestions. The below returns suggested trending search*/
export const getSuggestionsUrl = `${BASE_URL}/suggestion/search-suggestion`;

/** Filter URL , Accepts `POST` with payload*/
export const filterUrl = `${BASE_URL}/filter`;

/** Forms URL */
export const formsUrl = `${BASE_URL}/forms`;

/** COmments */
export const commentUrl = `${BASE_URL}/comment`;
/** Takes filter API features */
export const getProjectcommentUrl = `${BASE_URL}/comment/allComments`;

/** Jury - takes `:id` for delete and getOne requests. Also called for creating / inviting jury */
export const juryBaseUrl = `${BASE_URL}/jury`;
/** Pass `-GET /token` to accept jury invite */
export const acceptJuryInviteUrl = `${BASE_URL}/jury/invite/`;
/** Logged-in Accept / Decline by contest (notification actions). */
export const respondJuryInviteUrl = `${BASE_URL}/jury/respond`;
/** Email juror - POST request to send email invitation to juror */
export const emailJurorUrl = `${juryBaseUrl}/email`;
/** Invite external jurors - POST request to invite external jurors by email */
export const inviteExternalJurorUrl = `${juryBaseUrl}/external`;

/** View URL. Will allow us fetch views for specific projects. **NOTE** when signed in
 * user ?user=`id_of_signed_in_user` to get the views linked to that specific user. when not signed in
 * user the x-device-info as defined in the api header to fetch the details
 */
export const viewUrl = `${BASE_URL}/views`;

/** Vote URL */
export const voteUrl = `${BASE_URL}/vote`;

/** VoteR url */
export const voterUrl = `${BASE_URL}/voter`;

/** Audience URL
 * /my-watching -GET to get the thspians a user is subscribed to
 * /my-audience -GET to get the thspians subscribed to a user
 * /:id -PATCH to block a user
 * /:id - DELETE to unwatch a user
 */
export const audienceUrl = `${BASE_URL}/audience`;

export const hostUrl = `${BASE_URL}/host`;
export const partnerUrl = `${BASE_URL}/partner`;

/** Redeemable Codes, accepts a contest query param */
export const getRedeemableCodesUrl = `${BASE_URL}/reedemable-code`;
export const assignRedeemableCodeUrl = `${BASE_URL}/reedemable-code/send`;

/** Requests */
export const requestUrl = `${BASE_URL}/request`;

/** Score & Score category */
export const scoreCategoryUrl = `${BASE_URL}/scorecategory`;
export const scoreUrl = `${BASE_URL}/score`;

/** Link */
export const linkUrl = `${BASE_URL}/link`;
export const myLinksUrl = `${BASE_URL}/link/my-links`;

/** Talent */
export const talentUrl = `${BASE_URL}/talent`;
export const searchUserTalentUrl = `${BASE_URL}/talent/search`;
export const findTalentUrl = `${BASE_URL}/profiles/find-talent`;

/** Attendacne */
export const attendanceUrl = `${BASE_URL}/attendance`;
/** Ad Urls */
// {{URL}}ads/track?event=error&id={{advert}}
export const adsUrl = `${BASE_URL}/ads`;
export const trackAdUrl = `${adsUrl}/track`;
export const clickAdUrl = `${BASE_URL}/clicks`;

/**Upload Specific URL */
export const initiateMultipartDownloadUrl = `${projectUrl}/initiateMultipart`;
/** Get Sgned URL for multipart
 * takes {:id} of the project
 * partNumber e.g 100000
 * and uploadIpd = same as the id of the project
 * example => project/getMultipartSignedUrl/:id?partNumber=100000&uploadId={{project}}
 */
export const getMultiPartSignedUrl = `${projectUrl}/getMultipartSignedUrl`;

/** Complete the MultiPart Upload here */
export const completeMultiPartSignedUrl = `${projectUrl}/completeMultipart`;

/** Playlist */
export const playlistUrl = `${BASE_URL}/playlist`;
export const myPlaylistUrl = `${BASE_URL}/playlist/my-playlist`;

/** Creators Sandbox (courses) */
export const sandboxUrl = `${BASE_URL}/sandbox`;
export const sandboxExploreUrl = `${sandboxUrl}/explore`;
export const sandboxTeacherDashboardUrl = `${sandboxUrl}/teacher/dashboard`;
export const sandboxMyEnrollmentsUrl = `${sandboxUrl}/me/enrollments`;
export const sandboxMyAssignmentsUrl = `${sandboxUrl}/me/assignments`;
export const sandboxTeacherReviewsUrl = `${sandboxUrl}/teacher/reviews`;
export const sandboxOfficeHoursUrl = `${sandboxUrl}/office-hours`;

/** event */
export const eventsUrl = `${BASE_URL}/events`;

/** Event invite (Meeteor team invitations) */
export const getEventInviteDetailsUrl = `${BASE_URL}/event-invite`;
export const acceptEventInviteUrl = (token: string) => `${BASE_URL}/event-invite/${token}/accept`;
/** Tickets */
export const ticketsUrl = `${BASE_URL}/ticket`;

/** Refunds
 * The below takes a saleId/refund
 * like so /sales/:saleId/refund
 */
export const initateRefundUrl = `${BASE_URL}/refund/sales`;

/** The below takes an eventId/cancel
 * e.g /refund/event/:eventId/cancel
 */
export const cancelEventUrl = `${BASE_URL}/refund/event`;

/** Thougth url */
export const thougthUrl = `${BASE_URL}/thougth`;
/**Upload Specific URL */
export const initiateThougthMultipartUploadUrl = `${thougthUrl}/initiateMultipart`;
/** Get Sgned URL for multipart
 * takes {:id} of the project
 * partNumber e.g 100000
 * and uploadIpd = same as the id of the project
 * example => project/getMultipartSignedUrl/:id?partNumber=100000&uploadId={{project}}
 */
export const getThougthMultiPartSignedUrl = `${thougthUrl}/getMultipartSignedUrl`;

/** Complete the MultiPart Upload here */
export const completeThougthMultiPartSignedUrl = `${thougthUrl}/completeMultipart`;

export const getSignedUrlForThougthUrl = `${BASE_URL}/thougth/getSignedUrl`;

/** Mixed Uploader
 * accepts POST request with :id
 * pass collection {name of the doc e.g audition, contest e.t.c}
 * path e.g media
 * directory e.g images, video e.t.c
 * also pass extension as a query => extension=mp4 or jpeg
 */
export const genericUploaderUrl = `${BASE_URL}/mixed/upload`;

export const searchUserProjectsUrl = `${BASE_URL}/mixed/search-user-projects`;

/**
 * POST call
 * payload `
 *  category ~ audition | contest
 *  id ~ id of the doc
 *  payload {
 * ... key, value pair
 * }
 * `
 */
export const adminUpdateUrl = `${BASE_URL}/mixed/update`;

/** Sound */
export const soundUrl = `${BASE_URL}/sounds`;

/**Credit / Pastwork */
export const pastWorkUrl = `${BASE_URL}/pastwork`;

export const socialLoginAuthUrl = `${BASE_URL}/auth`;
export const socialLoginConfirmAuthUrl = `${BASE_URL}/auth-confirm`;

/** Buzzbridge */
export const buzzbridgeCampaignUrl = `${BASE_URL}/campaigns`;
export const campaignParticipantBroadcastUrl = (campaignId: string) =>
    `${buzzbridgeCampaignUrl}/${campaignId}/participants/broadcast-message`;
export const campaignDeliverableOptionsUrl = `${buzzbridgeCampaignUrl}/deliverable-options`;
export const campaignReportCapabilitiesUrl = `${buzzbridgeCampaignUrl}/report/capabilities`;
export const campaignReportUrl = (campaignId: string) => `${buzzbridgeCampaignUrl}/${campaignId}/report`;
export const campaignReportContentUrl = (campaignId: string) => `${buzzbridgeCampaignUrl}/${campaignId}/report/content`;
export const campaignReportCreatorsUrl = (campaignId: string) =>
    `${buzzbridgeCampaignUrl}/${campaignId}/report/creators`;
export const campaignReportSyncStatusUrl = (campaignId: string) =>
    `${buzzbridgeCampaignUrl}/${campaignId}/report/sync-status`;
export const campaignReportSyncUrl = (campaignId: string) => `${buzzbridgeCampaignUrl}/${campaignId}/report/sync`;
export const campaignReportBoostUrl = (campaignId: string) => `${buzzbridgeCampaignUrl}/${campaignId}/report/boost`;

/** AdHub (same JWT + X-AdHub-Brand-Id) */
export const adhubBaseUrl = `${BASE_URL}/adhub`;
export const adhubConnectionsUrl = `${adhubBaseUrl}/connections`;
export const adhubConnectionPlatformUrl = (platform: string) => `${adhubConnectionsUrl}/${platform}`;
export const adhubConnectionOAuthUrl = (platform: string, redirectUri: string) =>
    `${adhubConnectionPlatformUrl(platform)}/oauth-url?redirect_uri=${encodeURIComponent(redirectUri)}`;
export const adhubConnectionOAuthExchangeUrl = (platform: string) =>
    `${adhubConnectionPlatformUrl(platform)}/oauth-exchange`;
export const campaignPauseUrl = (campaignId: string) => `${buzzbridgeCampaignUrl}/${campaignId}/pause`;
export const campaignResumeUrl = (campaignId: string) => `${buzzbridgeCampaignUrl}/${campaignId}/resume`;
export const campaignCloseUrl = (campaignId: string) => `${buzzbridgeCampaignUrl}/${campaignId}/close`;
export const campaignDuplicateUrl = (campaignId: string) => `${buzzbridgeCampaignUrl}/${campaignId}/duplicate`;
export const campaignSeatIncreasePreviewUrl = (campaignId: string, additionalSeats: number) =>
    `${buzzbridgeCampaignUrl}/${campaignId}/seat-increase/preview?additional_seats=${additionalSeats}`;
export const campaignSeatIncreaseUrl = (campaignId: string) => `${buzzbridgeCampaignUrl}/${campaignId}/seat-increase`;
export const campaignSendInvitesUrl = (campaignId: string) => `${buzzbridgeCampaignUrl}/${campaignId}/send-invites`;
export const campaignPendingInvitesUrl = (campaignId: string) =>
    `${buzzbridgeCampaignUrl}/${campaignId}/pending-invites`;
/** Favourite an applicant for a specific campaign (POST body: { influencer_id }). */
export const campaignApplicantFavoritesUrl = (campaignId: string) =>
    `${buzzbridgeCampaignUrl}/${campaignId}/applicant-favorites`;
export const campaignApplicantFavoriteUrl = (campaignId: string, influencerId: string) =>
    `${buzzbridgeCampaignUrl}/${campaignId}/applicant-favorites/${influencerId}`;
export const campaignSampleVideoSignedUrl = (campaignId: string, extension: string) =>
    `${buzzbridgeCampaignUrl}/${campaignId}/sample-video/signed-url?extension=${extension}`;
export const campaignSampleVideoUrl = (campaignId: string) => `${buzzbridgeCampaignUrl}/${campaignId}/sample-video`;
export const campaignSampleVideoDeleteUrl = (campaignId: string, videoId: string) =>
    `${buzzbridgeCampaignUrl}/${campaignId}/sample-video/${videoId}`;
export const campaignParticipantsUrl = `${BASE_URL}/campaign-participants`;
export const circuulClickUrl = `${BASE_URL}/circuul/click`;
export const circuulCampaignReportUrl = (campaignId: string) => `${BASE_URL}/circuul/campaigns/${campaignId}/report`;
export const requestPayoutCancelUrl = (participantId: string) =>
    `${campaignParticipantsUrl}/${participantId}/request-payout-cancel`;
export const adminApprovePayoutCancelUrl = (participantId: string) =>
    `${campaignParticipantsUrl}/${participantId}/payout-cancel/approve`;
export const adminRejectPayoutCancelUrl = (participantId: string) =>
    `${campaignParticipantsUrl}/${participantId}/payout-cancel/reject`;
export const acceptCampaignInviteUrl = (participantId: string) =>
    `${campaignParticipantsUrl}/${participantId}/accept-invite`;
export const declineCampaignInviteUrl = (participantId: string) =>
    `${campaignParticipantsUrl}/${participantId}/decline-invite`;
export const cancelCampaignInviteUrl = (participantId: string) =>
    `${campaignParticipantsUrl}/${participantId}/cancel-invite`;
export const campaignParticipantThreadMarkReadUrl = (participantId: string) =>
    `${campaignParticipantsUrl}/${participantId}/messages/mark-read`;
export const campaignThreadsMarkAllReadUrl = (campaignId: string) =>
    `${buzzbridgeCampaignUrl}/${campaignId}/messages/mark-all-read`;
export const campaignWalletUrl = `${BASE_URL}/campaign-wallet`;
export const resourceTeamsUrl = `${BASE_URL}/resource-teams`;
export const campaignWalletAdminCreditUrl = `${campaignWalletUrl}/admin/credit`;
export const campaignWalletFundVerifyUrl = `${campaignWalletUrl}/fund/verify`;
export const campaignWalletFundVerifyFlutterwaveUrl = `${campaignWalletUrl}/fund/verify-flutterwave`;
export const accountBalanceUrl = `${BASE_URL}/campaign-account/balance`;
/** Legacy Account (Earned Revenue / contest prizes) balance + payout eligibility */
export const creatorAccountBalanceUrl = `${BASE_URL}/account/balance`;
export const creatorAccountPayoutInfoUrl = `${BASE_URL}/account/payout-info`;

/** Influencer commission wallet (pending + cleared + enrollments). */
export const commissionWalletUrl = `${BASE_URL}/commission/wallet`;
export const commissionWalletCashOutUrl = `${BASE_URL}/commission/wallet/cash-out`;
export const commissionActivityUrl = `${BASE_URL}/commission/activity`;
export const campaignAccountPayoutInfoUrl = `${BASE_URL}/campaign-account/payout-info`;
export const sandboxAccountPayoutInfoUrl = `${BASE_URL}/sandbox-account/payout-info`;
export const sandboxAccountBalanceUrl = `${BASE_URL}/sandbox-account/balance`;
export const sandboxAccountPaymentHistoryUrl = `${BASE_URL}/sandbox-account/payment-history`;
export const myPayoutsUrl = `${BASE_URL}/request/my-payouts`;
export const socialPostsUrl = `${BASE_URL}/social-posts`;
export const connectedPlatformsUrl = `${BASE_URL}/social-posts/connected-platforms`;
export const tiktokCreatorInfoUrl = `${BASE_URL}/social-posts/tiktok/creator-info`;
export const instagramAutomationStatusUrl = `${BASE_URL}/instagram-automation/status`;
export const instagramAutomationOAuthUrl = `${BASE_URL}/instagram-automation/oauth-url`;
export const instagramAutomationMediaUrl = (limit = 5, after?: string) => {
    const params = new URLSearchParams({ limit: String(limit) });
    if (after) params.set('after', after);
    return `${BASE_URL}/instagram-automation/media?${params.toString()}`;
};
export const instagramAutomationPostsUrl = `${BASE_URL}/instagram-automation/posts`;
export const instagramAutomationPostUrl = (socialPostId: string) =>
    `${BASE_URL}/instagram-automation/posts/${socialPostId}`;
export const recentSocialPostsUrl = (platform: string, limit = 10) =>
    `${BASE_URL}/social-posts/recent-posts/${platform}?limit=${limit}`;
export const influencersUrl = `${BASE_URL}/influencers`;
export const savedInfluencersUrl = `${BASE_URL}/saved-influencers`;
/** Public creator card — optional auth; lookup by account userName (with or without @) */
export const influencersPublicByUserNameUrl = (userName: string) =>
    `${influencersUrl}/public/${encodeURIComponent(userName.replace(/^@/, ''))}`;
export const influencersSearchFiltersUrl = `${influencersUrl}/search/filters`;
export const influencersSearchUrl = `${influencersUrl}/search`;
/** Guest pre-link (no JWT): creates influencer + claim_token — see influencer linking contract */
export const influencersLinkUrl = `${influencersUrl}/link`;
/** Guest OAuth exchange (no JWT): code → influencer_id + claim_token */
export const influencersGuestOAuthLinkUrl = `${influencersUrl}/guest/oauth-link`;
/** Logged-in user: attach platform via OAuth code */
export const influencersOAuthConnectUrl = `${influencersUrl}/oauth/connect`;
export const influencersFromConnectedInstagramUrl = `${influencersUrl}/from-connected/instagram`;
export const brandUrl = `${BASE_URL}/brands`;
export const brandReviewsUrl = (brandId: string) => `${brandUrl}/${brandId}/reviews`;
export const brandReviewByIdUrl = (reviewId: string) => `${BASE_URL}/brand-reviews/${reviewId}`;
export const influencerReviewsUrl = (influencerId: string) => `${influencersUrl}/${influencerId}/reviews`;
export const influencerReviewByIdUrl = (reviewId: string) => `${BASE_URL}/influencer-reviews/${reviewId}`;
export const brandAuthUrl = `${BASE_URL}/brand-auth`;

/** Brand Manage / content ops (Boxofix brand-ops) */
export const brandOpsUrl = `${BASE_URL}/brand-ops`;
export const brandOpsHomeStatsUrl = `${brandOpsUrl}/home/stats`;
export const brandOpsAccessUrl = `${brandOpsUrl}/access`;
export const brandOpsTeamUrl = `${brandOpsUrl}/team`;
export const brandOpsTeamMemberUrl = (memberId: string) => `${brandOpsTeamUrl}/${memberId}`;
export const brandOpsTeamMemberResendUrl = (memberId: string) => `${brandOpsTeamMemberUrl(memberId)}/resend`;
export const brandOpsTeamAcceptUrl = `${brandOpsTeamUrl}/accept`;
export const brandOpsTeamMineUrl = `${brandOpsTeamUrl}/mine`;
export const brandOpsContractsUrl = `${brandOpsUrl}/contracts`;
export const brandOpsContractsMineUrl = `${brandOpsContractsUrl}/mine`;
export const brandOpsContractUrl = (contractId: string) => `${brandOpsContractsUrl}/${contractId}`;
export const brandOpsContractDispatchUrl = (contractId: string) => `${brandOpsContractUrl(contractId)}/dispatch`;
export const brandOpsContractRenewUrl = (contractId: string) => `${brandOpsContractUrl(contractId)}/renew`;
export const brandOpsContractSignUrl = (contractId: string) => `${brandOpsContractUrl(contractId)}/sign`;
export const brandOpsCalendarUrl = `${brandOpsUrl}/calendar`;
export const brandOpsCalendarMediaPresignUrl = `${brandOpsCalendarUrl}/media-presign`;
export const brandOpsCalendarItemUrl = (itemId: string) => `${brandOpsCalendarUrl}/${itemId}`;
export const brandOpsCalendarApproveUrl = (itemId: string) => `${brandOpsCalendarItemUrl(itemId)}/approve`;
export const brandOpsCalendarPublishUrl = (itemId: string) => `${brandOpsCalendarItemUrl(itemId)}/publish`;
export const brandOpsSettingsUrl = `${brandOpsUrl}/settings`;
export const brandOpsContractPdfUrl = (contractId: string) => `${brandOpsContractUrl(contractId)}/pdf`;
export const brandOpsContractEscrowUrl = (contractId: string) => `${brandOpsContractUrl(contractId)}/escrow`;
export const brandOpsContractEscrowLockUrl = (contractId: string) => `${brandOpsContractEscrowUrl(contractId)}/lock`;
export const brandOpsContractEscrowPayoutUrl = (contractId: string) =>
    `${brandOpsContractEscrowUrl(contractId)}/payout`;
export const brandOpsContractEscrowReleaseUrl = (contractId: string) =>
    `${brandOpsContractEscrowUrl(contractId)}/release`;
export const brandOpsContractStrikesUrl = (contractId: string) => `${brandOpsContractUrl(contractId)}/strikes`;
export const brandOpsContractFreezeUrl = (contractId: string) => `${brandOpsContractUrl(contractId)}/freeze`;
export const brandOpsContractVoidUrl = (contractId: string) => `${brandOpsContractUrl(contractId)}/void`;
export const brandOpsContractApproveUrl = (contractId: string) => `${brandOpsContractUrl(contractId)}/approve`;
export const brandOpsContractReviewUrl = `${brandOpsContractsUrl}/review`;
export const brandOpsContractReviewSignUrl = `${brandOpsContractReviewUrl}/sign`;
export const brandOpsContractReviewDeclineUrl = `${brandOpsContractReviewUrl}/decline`;
export const brandOpsContractReviewClarifyUrl = `${brandOpsContractReviewUrl}/clarify`;
export const brandOpsContractClarificationsUrl = (contractId: string) =>
    `${brandOpsContractUrl(contractId)}/clarifications`;
export const brandOpsContractClarificationReplyUrl = (contractId: string, clarificationId: string) =>
    `${brandOpsContractClarificationsUrl(contractId)}/${clarificationId}/reply`;
export const brandOpsKnowledgeUrl = `${brandOpsUrl}/knowledge`;
export const brandOpsKnowledgeDocUrl = (docId: string) => `${brandOpsKnowledgeUrl}/${docId}`;
export const brandOpsAiPlaygroundUrl = `${brandOpsUrl}/ai/playground`;
export const brandOpsInboxUrl = `${brandOpsUrl}/inbox`;
export const brandOpsInboxStatusUrl = `${brandOpsInboxUrl}/status`;
export const brandOpsInboxActivityUrl = `${brandOpsInboxUrl}/activity`;
export const brandOpsInboxConversationsUrl = `${brandOpsInboxUrl}/conversations`;
export const brandOpsInboxConversationMessagesUrl = (conversationId: string) =>
    `${brandOpsInboxConversationsUrl}/${conversationId}/messages`;
export const brandOpsInboxSendMessageUrl = `${brandOpsInboxUrl}/messages`;
export const brandOpsInboxAutomationsUrl = `${brandOpsInboxUrl}/automations`;
export const brandOpsInboxAutomationToggleUrl = (automationId: string) =>
    `${brandOpsInboxAutomationsUrl}/${automationId}/toggle`;
export const brandOpsInboxAutomationDeleteUrl = (automationId: string) =>
    `${brandOpsInboxAutomationsUrl}/${automationId}`;
export const brandOpsUgcAssetsUrl = `${brandOpsUrl}/ugc-assets`;

/** External Account URLs */
export const accountUrl = `${BASE_URL}/account`;
export const externalAccountInfoUrl = `${BASE_URL}/account/info`;
export const externalAccountUrl = `${BASE_URL}/account/external`;
export const patchExternalAccountUrl = (id: string) => `${BASE_URL}/account/external/${id}`;
export const deleteExternalAccountUrl = (id: string) => `${BASE_URL}/account/external/${id}`;

/** Payout recipient helpers (Paystack + Stripe + manual wire) */
export const payoutSupportedCountriesUrl = `${BASE_URL}/payout/supported-countries`;
export const payoutCountrySupportUrl = (country: string) =>
    `${BASE_URL}/payout/country-support?country=${encodeURIComponent(country)}`;
export const payoutBanksUrl = (query: string) => `${BASE_URL}/payout/banks${query ? `?${query}` : ''}`;
export const payoutStripeConfigUrl = (country: string) =>
    `${BASE_URL}/payout/stripe-config?country=${encodeURIComponent(country)}`;
export const payoutVerifyAccountUrl = `${BASE_URL}/payout/verify-account`;
export const payoutAdminRequestsUrl = `${BASE_URL}/payout/admin/requests`;
export const payoutAdminExecuteUrl = `${BASE_URL}/payout/admin/requests/execute`;

export const companyUrl = `${BASE_URL}/company`;
export const companyDetailsUrl = `${companyUrl}/details`;
export const companyReviewsUrl = `${BASE_URL}/companyreviews`;

export const positionsUrl = `${BASE_URL}/positions`;

export const affiliateUrl = `${BASE_URL}/affiliates`;

/** Token URLs */
export const tokenBalanceUrl = `${BASE_URL}/tokens/balance`;
export const tokenPackagesUrl = `${BASE_URL}/tokens/packages`;
export const tokenCountdownsUrl = `${BASE_URL}/tokens/countdown`;

/** Transaction URLs */
export const creditTransactionUrl = `${BASE_URL}/transaction/credit`;

/** Route Alias URL */
export const routeAliasUrl = `${BASE_URL}/route-alias`;

/** Email Templates URL */
export const emailTemplatesUrl = `${BASE_URL}/email-templates`;
export const sendEmailUrl = `${BASE_URL}/send-email`;
export const sendProductEmailUrl = `${BASE_URL}/send-email/product`;
export const productEmailCategoriesUrl = `${BASE_URL}/send-email/product-categories`;
export const emailLogsUrl = `${BASE_URL}/email-logs`;
export const emailLogStatsUrl = `${BASE_URL}/email-logs/stats`;

/** Per-user personal media library (public SEO bucket) — email editors / image pickers */
export const userMediaBaseUrl = `${BASE_URL}/user/media`;
export const userMediaUploadConfigUrl = `${userMediaBaseUrl}/upload-config`;
export const userMediaPresignUrl = `${userMediaBaseUrl}/presign`;
export const userMediaAssetsUrl = `${userMediaBaseUrl}/assets`;
export const userMediaAssetByIdUrl = (id: string) => `${userMediaAssetsUrl}/${id}`;
export const userMediaMultipartInitiateUrl = `${userMediaBaseUrl}/multipart/initiate`;
export const userMediaMultipartPartUrl = `${userMediaBaseUrl}/multipart/part-url`;
export const userMediaMultipartCompleteUrl = `${userMediaBaseUrl}/multipart/complete`;

/** Generic contact support (mildProtect) — enterprise sales inquiry uses this */
export const supportContactUrl = `${BASE_URL}/support/contact`;

/** Campaign host subscription (brand dashboard) */
export const campaignHostPackagesUrl = `${BASE_URL}/campaign-host-packages`;
export const syncCampaignHostFlutterwavePlansUrl = (id: string) =>
    `${campaignHostPackagesUrl}/${id}/sync-flutterwave-plans`;
export const campaignHostSubscriptionsUrl = `${BASE_URL}/campaign-host-subscriptions`;
export const campaignHostSubscriptionsPricingUrl = `${campaignHostSubscriptionsUrl}/pricing`;
export const campaignHostSubscriptionsMineUrl = `${campaignHostSubscriptionsUrl}/mine`;
export const campaignHostSubscriptionsCreationAccessUrl = `${campaignHostSubscriptionsUrl}/creation-access`;
export const campaignHostSubscriptionsSubscribeUrl = `${campaignHostSubscriptionsUrl}/subscribe`;
export const campaignHostSubscriptionsPurchaseLtdUrl = `${campaignHostSubscriptionsUrl}/purchase-ltd`;
export const campaignHostSubscriptionsBillingHistoryUrl = `${campaignHostSubscriptionsUrl}/billing-history`;
export const campaignHostSubscriptionsVerifyPaystackUrl = `${campaignHostSubscriptionsUrl}/verify-paystack`;
export const campaignHostSubscriptionsVerifyFlutterwaveUrl = `${campaignHostSubscriptionsUrl}/verify-flutterwave`;
export const campaignHostSubscriptionByIdUrl = (id: string) => `${campaignHostSubscriptionsUrl}/${id}`;
export const campaignHostSubscriptionCancelUrl = (id: string) => `${campaignHostSubscriptionsUrl}/${id}/cancel`;
export const campaignHostEnterprisePackageAdminUrl = `${campaignHostSubscriptionsUrl}/admin/enterprise/package`;
export const campaignHostEnterpriseGrantAdminUrl = `${campaignHostSubscriptionsUrl}/admin/enterprise/grant`;
/** Super-admin: campaign host subscription directory (paid / in-use) */
export const adminCampaignHostSubscriptionsUrl = `${campaignHostSubscriptionsUrl}/admin/subscriptions`;
export const adminCancelCampaignHostSubscriptionUrl = (id: string) =>
    `${campaignHostSubscriptionsUrl}/admin/subscriptions/${id}/cancel`;
/** BuzzBridge loyalty & referral */
export const buzzbridgeLoyaltyBaseUrl = `${BASE_URL}/buzzbridge-loyalty`;
export const buzzbridgeLoyaltyDashboardUrl = `${buzzbridgeLoyaltyBaseUrl}/dashboard`;
export const buzzbridgeLoyaltyNetworkUrl = `${buzzbridgeLoyaltyBaseUrl}/network`;
export const buzzbridgeLoyaltyMemberUrl = (referralId: string) => `${buzzbridgeLoyaltyBaseUrl}/network/${referralId}`;
export const buzzbridgeLoyaltyInviteUrl = `${buzzbridgeLoyaltyBaseUrl}/invite`;
export const buzzbridgeLoyaltyWalletUrl = `${buzzbridgeLoyaltyBaseUrl}/wallet`;
export const buzzbridgeLoyaltyWalletLedgerUrl = `${buzzbridgeLoyaltyBaseUrl}/wallet/ledger`;
export const buzzbridgeLoyaltyPointsTransactionsUrl = `${buzzbridgeLoyaltyBaseUrl}/points/transactions`;
export const buzzbridgeLoyaltyRedemptionCatalogUrl = `${buzzbridgeLoyaltyBaseUrl}/redemption/catalog`;
export const buzzbridgeLoyaltyRedemptionRedeemUrl = `${buzzbridgeLoyaltyBaseUrl}/redemption/redeem`;
export const buzzbridgeLoyaltyWithdrawUrl = `${buzzbridgeLoyaltyBaseUrl}/wallet/withdraw`;
export const buzzbridgeLoyaltyAdminWithdrawalsUrl = `${buzzbridgeLoyaltyBaseUrl}/admin/withdrawals`;
export const buzzbridgeLoyaltyAdminWithdrawalUrl = (withdrawalId: string) =>
    `${buzzbridgeLoyaltyBaseUrl}/admin/withdrawals/${withdrawalId}`;
export const buzzbridgeLoyaltyAdminGrantUrl = `${buzzbridgeLoyaltyBaseUrl}/admin/grant`;
export const buzzbridgeLoyaltyAdminOverviewUrl = `${buzzbridgeLoyaltyBaseUrl}/admin/overview`;
export const buzzbridgeLoyaltyAdminLeaderboardUrl = `${buzzbridgeLoyaltyBaseUrl}/admin/leaderboard`;
export const buzzbridgeLoyaltyAdminUserUrl = (userId: string) => `${buzzbridgeLoyaltyBaseUrl}/admin/users/${userId}`;

export const campaignHostSubscriptionUpdatePaymentMethodUrl = (id: string) =>
    `${campaignHostSubscriptionsUrl}/${id}/update-payment-method`;
export const campaignHostLtdPromotionAdminUrl = `${campaignHostSubscriptionsUrl}/admin/ltd-promotion`;
